export default "__VITE_ASSET__DPRGWZZS__"